<template>
  <div class="server-info">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Server Info</div>
      </q-card-section>
      <q-separator />
     <div class="card-section-content">
        <span class="content" v-html="getServerInfo.Info"></span>
     </div>
    </q-card>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadLinkPage',
  computed: {
    ...mapGetters({
      getServerInfo: 'home/getServerInfo'
    })
  }
}
</script>
<style lang="scss">
.server-info {
  .my-card {
    background-color: $backgroundHeader;
    
    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-section-content {
      background-color: $background;
      padding: 8px;
      .content {
        color: white;
      }
    }

    .card-content {
      background-color: $background;
      color: white;
    }
  }
}
</style>